import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MissionPage } from './pages/MissionPage';
function useHashRoute() {
  const getRoute = () => window.location.hash;
  const [hash, setHash] = useState(getRoute);
  useEffect(() => {
    const handler = () => setHash(getRoute());
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);
  return hash;
}
export function App() {
  const hash = useHashRoute();
  if (hash === '#/mission') return <MissionPage data-id="element-0" />;
  return <LandingPage data-id="element-1" />;
}